import React from "react";
import { Quote } from "lucide-react";

export default function Testimonials({ t }) {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 md:py-32 bg-[#0F2C29] text-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-14 max-w-2xl">
          <div
            className="text-[12px] tracking-[0.28em] uppercase text-white/60 mb-4"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            — {t.testimonials.eyebrow}
          </div>
          <h2
            className="text-[36px] sm:text-[44px] leading-[1.05] tracking-tight font-medium"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            {t.testimonials.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10">
          {t.testimonials.items.map((q, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-[#0F2C29] p-8 md:p-10 flex flex-col"
            >
              <Quote className="w-7 h-7 text-white/40 mb-6" strokeWidth={1.2} />
              <blockquote
                className="text-[18px] leading-relaxed flex-1"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                "{q.quote}"
              </blockquote>
              <figcaption
                className="mt-8 pt-6 border-t border-white/15 flex items-baseline justify-between"
                style={{ fontFamily: "'Manrope', sans-serif" }}
              >
                <span className="text-[14px] font-semibold tracking-wide">
                  {q.name}
                </span>
                <span className="text-[11px] tracking-[0.22em] uppercase text-white/60">
                  {q.place}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
